import { $, $$ } from '@3pc/dom';
import Bus from 'modules/event-bus';
import { Accordion } from '@3pc/accordion';

class Header {
  static BREAKPOINT = 769;

  constructor(props) {
    this.container = props.container;
    this.burger = props.burger;
    this.menu = props.menu;
    this.handlers = props.handlers;
    this.links = props.links;
    this.subLinks = props.subLinks;
    this.menuIsActive = false;
    this.accordionAlreadyActive = false;
    this.accordionInstances = [];
    this.arraySublistContainers = $$('.navigation__main-sublist-inner');
  }

  showMenu = () => {
    this.menu.classList.add('is-active');
    this.burger.classList.add('is-open');
    this.burger.setAttribute('aria-expanded', 'true');
    $('body').classList.add('menu-active');
    $('html').classList.add('menu-active');
  };

  hideMenu = () => {
    this.menu.classList.remove('is-active');
    this.burger.classList.remove('is-open');
    this.burger.setAttribute('aria-expanded', 'false');
    $('body').classList.remove('menu-active');
    $('html').classList.remove('menu-active');
  };

  toggleMenu = () => {
    if (this.menuIsActive) {
      this.menuIsActive = false;
      this.hideMenu();
    } else {
      this.menuIsActive = true;
      this.showMenu();
    }
  };

  handleResize = () => {
    if (window.innerWidth > Header.BREAKPOINT && this.menuIsActive) {
      this.hideMenu();
    }

    this.initializeAccordion();
  };

  initKeyboardAccessibility = () => {
    const focusSkipLink = () => {
      const skipLink = document.querySelector('.skip-navigation__link');
      skipLink.focus();
    };

    const closeDropdown = () => {
      const handlerOpen = this.handlers.find(handler =>
        handler.classList.contains('is-open')
      );

      if (handlerOpen) {
        handlerOpen.click();
      }
    };

    const handleKeydown = event => {
      if (event.key === 'Escape') {
        closeDropdown();
        focusSkipLink();
      }
    };

    window.addEventListener('keydown', handleKeydown);
  };

  initAccordion = () => {
    if (this.handlers.length) {
      this.handlers.forEach(handler => {
        const target = handler.nextElementSibling;
        const accordion = new Accordion({
          target,
          targetInner: $('.navigation__main-sublist-inner', target),
          handler,
          easing: 'easeInOutQuart',
          duration: 120,
          initOpened: false,
          openClassName: 'is-open',
        });
        accordion.init();
        this.accordionInstances.push(accordion);
      });
    }
  };

  // Destroy existing sub-accordion instances
  destroyAccordion = () => {
    if (this.accordionAlreadyActive) {
      this.accordionInstances.forEach(accordionInstances =>
        accordionInstances.destroy()
      );
      this.accordionInstances = [];
    }
  };

  initializeAccordion = () => {
    this.destroyAccordion();
    this.initAccordion();
    if (window.innerWidth >= Header.BREAKPOINT) {
      this.initKeyboardAccessibility();
    }
    this.accordionAlreadyActive = true;
  };

  // prevent multiple dropdown openings simultaneously
  closeCurrentOpenDropdown = () => {
    const indexHandlerOpen = this.handlers.findIndex(handler =>
      handler.classList.contains('is-open')
    );

    // if open dropdown & it's corresponding instance is found, close it
    if (indexHandlerOpen !== -1 && this.accordionInstances[indexHandlerOpen]) {
      this.accordionInstances[indexHandlerOpen].close();
    }
  };

  handleOnClick = () => {
    if (window.innerWidth >= Header.BREAKPOINT) {
      this.closeCurrentOpenDropdown();
    }
  };

  bindEvents = () => {
    this.burger.addEventListener('click', this.toggleMenu);
    this.handlers.forEach(handler => {
      handler.addEventListener('click', this.handleOnClick);
    });
  };

  init = () => {
    Bus.subscribe('resize', 'Navigation', this.handleResize);
    this.bindEvents();
    this.initializeAccordion();
  };
}

const header = $('.navigation');

if (header) {
  new Header({
    container: header,
    burger: $('.burger-menu', header),
    menu: $('.navigation__inner', header),
    handlers: $$('.navigation__main-handler', header),
    links: $$('.navigation__main-link', header),
    subLinks: $$('.navigation__main-sublink', header),
  }).init();
}
